import { createFileRoute } from '@tanstack/react-router'

import Filter from '@/components/monitors-route/call-monitor/filter.jsx'
import { CallMonitorTable } from '@/components/monitors-route/call-monitor/table.jsx'

export const Route = createFileRoute('/_auth/monitors/call-monitor')({
  component: CallMonitor,
})

function CallMonitor() {
  return (
    <div>
      <div className="gap-4 p-4 pb-1">
        <Filter />
      </div>
      <div className="flex-grow gap-4 overflow-auto p-4 pt-1">
        <CallMonitorTable />
      </div>
    </div>
  )
}
